import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Button, Form } from "react-bootstrap";
import { Switch, Table } from "antd";
import { BsFile, BsFileArrowDown, BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { alertMessage } from "../../utils/AlertService";
import { DOCUMENT_TYPE_COLUMN, DOCUMENT_MASTER_COLUMN } from "../constant/AppConstant";
import InventoryReportData from "./DocumentData";
import { useDeleteDocumentTypeMutation, useGetAllDocumentTypeMutation, useGetDocumentTypeWithSearchMutation } from "../../redux-toolkit/services/documentTypeService";
import { useDeleteDocumentMasterMutation, useGetAllDocumentMasterMutation, useGetDocumentMasterWithSearchMutation } from "../../redux-toolkit/services/documentMasterService";
import { getAllDocumentTypeBySearch, getAllDocumentTypeDetails, getDocumentTypeTotalRecords, setAllDocumentTypeBySearch, setDocumentType } from "../../redux-toolkit/slices/documentTypeSlice";
import { getAllDocumentMasterBySearch, getAllDocumentMasterDetails, getDocumentMasterTotalRecords, setAllDocumentMasterBySearch, setDocumentMaster } from "../../redux-toolkit/slices/documentMasterSlice";
import { FaFileAlt } from "react-icons/fa";

type Props = {};
const Document = (props: Props) => {

    const params = useParams();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const dispatch = useDispatch();

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [selectedFile, setSelectedFile]: any = useState(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [previewType, setPreviewType]: any = useState<string | null>(null);

    //getMutations
    const [getAllDocumentType, getAllDocumentTypeResponse] = useGetAllDocumentTypeMutation();
    const [getAllDocumentMaster, getAllDocumentMasterResponse] = useGetAllDocumentMasterMutation();

    //get by search
    const [getDocumentTypeBySearch, documentTypeBySearchResponse] = useGetDocumentTypeWithSearchMutation();
    const [getDocumentMasterBySearch, documentMasterBySearchResponse] = useGetDocumentMasterWithSearchMutation();

    //delete mutation  
    const [deleteDocumentType, deleteDocumentTypeResponse] = useDeleteDocumentTypeMutation()
    const [deleteDocumentMaster, deleteDocumentMasterResponse] = useDeleteDocumentMasterMutation()


    //totalRecords
    const totalDocumentType: any = useAppSelector(getDocumentTypeTotalRecords);
    const totalDocumentMaster: any = useAppSelector(getDocumentMasterTotalRecords);

    //selector
    const documentTypeData: any = useAppSelector(getAllDocumentTypeDetails);
    const documentMasterData: any = useAppSelector(getAllDocumentMasterDetails);
    const documentTypeSearchData: any = useAppSelector(getAllDocumentTypeBySearch);
    const documentMasterSearchData: any = useAppSelector(getAllDocumentMasterBySearch);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.DOCUMENT_TYPE:
                setReportName(REPORT_NAME.DOCUMENT_TYPE)
                break;
            case REPORT_PATH.DOCUMENT_MASTER:
                setReportName(REPORT_NAME.DOCUMENT_MASTER)
                break;
            default:
        }
    }, [params.reportType]);



    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                        {reportName === REPORT_NAME.DOCUMENT_MASTER && (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleFileShow(record);
                                }}
                            >
                                <FaFileAlt size={18} color="#0078d4" />
                            </div>
                        )}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.DOCUMENT_TYPE && DOCUMENT_TYPE_COLUMN) {
            DOCUMENT_TYPE_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.DOCUMENT_MASTER && DOCUMENT_MASTER_COLUMN) {
            DOCUMENT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.DOCUMENT_TYPE) {
            getAllDocumentType({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.DOCUMENT_MASTER) {
            getAllDocumentMaster({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
    }, [reportName]);


    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.DOCUMENT_TYPE) {
                getAllDocumentType({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.DOCUMENT_MASTER) {
                getAllDocumentMaster({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }
            setCall("N");
        }
    }, [call]);


    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.DOCUMENT_TYPE) {
            getAllDocumentType({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.DOCUMENT_MASTER) {
            getAllDocumentMaster({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.DOCUMENT_TYPE) {
            deleteDocumentType({
                id: record.id,
                token: token,
            });
        } else if (reportName === REPORT_NAME.DOCUMENT_MASTER) {
            deleteDocumentMaster({
                id: record.id,
                token: token,
            });
        }
    };


    useEffect(() => {
        if (deleteDocumentTypeResponse.isSuccess) {
            if (deleteDocumentTypeResponse.data?.isActive) {
                alertMessage("Document Type enabled successfully", "success");
            } else {
                alertMessage("Document Type deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteDocumentTypeResponse.isError) {
            alertMessage("Error while deleting Inventory Type", "error");
        }
    }, [deleteDocumentTypeResponse.isSuccess, deleteDocumentTypeResponse.isError]);

    useEffect(() => {
        if (deleteDocumentMasterResponse.isSuccess) {
            if (deleteDocumentMasterResponse.data?.isActive) {
                alertMessage("Document Master enabled successfully", "success");
            } else {
                alertMessage("Document Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteDocumentMasterResponse.isError) {
            alertMessage("Error while deleting Document Master", "error");
        }
    }, [deleteDocumentMasterResponse.isSuccess, deleteDocumentMasterResponse.isError]);

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    const handleFileShow = (record: any) => {
        if (!(record.fileData)) return;

        // Revoke old preview if exists
        if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
        }

        let mimeType = "application/octet-stream";

        if ((record.fileData).startsWith("/9j")) mimeType = "image/jpeg";
        else if ((record.fileData).startsWith("iVBOR")) mimeType = "image/png";
        else if ((record.fileData).startsWith("JVBER")) mimeType = "application/pdf";
        else if ((record.fileData).startsWith("UEsDB")) mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // XLSX
        else if ((record.fileData).startsWith("PK")) mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // DOCX (optional)

        // Convert Base64 → Blob
        const byteCharacters = atob((record.fileData));
        const byteNumbers = new Array(byteCharacters.length).fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });

        const url = URL.createObjectURL(blob);
        setPreviewUrl(url);
        setPreviewType(mimeType);
    }

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.DOCUMENT_TYPE) {
            getDocumentTypeBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.DOCUMENT_MASTER) {
            getDocumentMasterBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (documentTypeBySearchResponse.isSuccess) {
            dispatch(setAllDocumentTypeBySearch(documentTypeBySearchResponse));
        } else if (documentTypeBySearchResponse.isError) {
            let response: any = documentTypeBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [documentTypeBySearchResponse.isSuccess, documentTypeBySearchResponse.isError]);

    useEffect(() => {
        if (documentMasterBySearchResponse.isSuccess) {
            dispatch(setAllDocumentMasterBySearch(documentMasterBySearchResponse));
        } else if (documentMasterBySearchResponse.isError) {
            let response: any = documentMasterBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [documentMasterBySearchResponse.isSuccess, documentMasterBySearchResponse.isError]);

    useEffect(() => {
        if (getAllDocumentTypeResponse.isSuccess) {
            dispatch(setDocumentType(getAllDocumentTypeResponse));
        } else if (getAllDocumentTypeResponse.isError) {
            let response: any = getAllDocumentTypeResponse.error;
            alertMessage(response, "error");
        }

    }, [getAllDocumentTypeResponse.isSuccess, getAllDocumentTypeResponse.isError]);

    useEffect(() => {
        if (getAllDocumentMasterResponse.isSuccess) {
            dispatch(setDocumentMaster(getAllDocumentMasterResponse));
        } else if (getAllDocumentMasterResponse.isError) {
            let response: any = getAllDocumentMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [getAllDocumentMasterResponse.isSuccess, getAllDocumentMasterResponse.isError]);

    const buildDocumentType = (data: any) => {
        let temp: any = [];

        data.forEach((element: any) => {

            temp.push({
                id: element.id,
                name: element?.name,
                code: element?.code,
                description: element?.description,
                entityTypeMaster: element?.entityTypeMaster ? element?.entityTypeMaster.name : "-",
                isMandatory: element?.isMandatory,
                expiryApplicable: element?.expiryApplicable,
                fileFormat: element?.fileFormat,
                status: element?.status,
            });
        });
        setDatasource(temp);
    };

    const buildDocumentMaster = (data: any) => {
        let temp: any = [];

        data.forEach((element: any) => {

            temp.push({
                id: element.id,
                documentName: element?.documentName,
                documentNumber: element?.documentNumber,
                documentType: element?.documentType ? element?.documentType.name : "-",
                entityMaster: element?.entityMaster ? element?.entityMaster.name : "-",
                entityTypeMaster: element?.entityTypeMaster ? element?.entityTypeMaster.name : "-",
                verificationStatus: element?.verificationStatus,
                fileName: element?.fileName,
                fileData: element?.fileData,
                status: element?.status,
            });
        });
        setDatasource(temp);
    };

    useEffect(() => {
        if (documentTypeData && reportName === REPORT_NAME.DOCUMENT_TYPE) {
            buildDocumentType(documentTypeData);
        }
    }, [documentTypeData]);

    useEffect(() => {
        if (documentMasterData && reportName === REPORT_NAME.DOCUMENT_MASTER) {
            buildDocumentMaster(documentMasterData);
        }
    }, [documentMasterData]);

    useEffect(() => {
        if (documentTypeSearchData && reportName === REPORT_NAME.DOCUMENT_TYPE) {
            buildDocumentType(documentTypeSearchData);
        }
    }, [documentTypeSearchData]);

    useEffect(() => {
        if (documentMasterSearchData && reportName === REPORT_NAME.DOCUMENT_MASTER) {
            buildDocumentMaster(documentMasterSearchData);
        }
    }, [documentMasterSearchData]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                        // onClick={() => {
                        //     setActionType(ACTION_TYPE.ADD_ACTION);
                        // }}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {
                        getAllDocumentTypeResponse.isLoading ||
                            getAllDocumentMasterResponse.isLoading ||

                            documentTypeBySearchResponse.isLoading ||
                            documentTypeBySearchResponse.isLoading ||

                            deleteDocumentTypeResponse.isLoading ||
                            deleteDocumentMasterResponse.isLoading ? (

                            <Loading />
                        ) : (
                            ""
                        )
                    }

                    {show && (
                        <InventoryReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.DOCUMENT_TYPE:
                                    return totalDocumentType;
                                case REPORT_NAME.DOCUMENT_MASTER:
                                    return totalDocumentMaster;
                                default:
                                    return [];
                            }
                        })(),
                        // hideOnSinglePage: true,  
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
            <div className="file-preview" style={{ marginTop: "20px" }}>
                {previewUrl && (
                    <>
                        {/* IMAGE VIEWER */}
                        {(previewType.includes("image")) && (
                            <div>
                                <a
                                    href={previewUrl}
                                    download="image"
                                    style={{
                                        display: "inline-block",
                                        marginTop: "10px",
                                        color: "#0078d4",
                                        fontWeight: 600,
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                >
                                    Download Image
                                </a>
                                <img
                                    src={previewUrl}
                                    alt="Preview"
                                    style={{ maxWidth: "100%", borderRadius: "8px" }}
                                />
                            </div>

                        )}

                        {/* PDF VIEWER */}
                        {previewType === "application/pdf" && (
                            <iframe
                                src={previewUrl}
                                width="100%"
                                height="500px"
                                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                            />
                        )}

                        {/* EXCEL / WORD / ZIP — cannot be previewed */}
                        {(previewType.includes("spreadsheet") ||
                            previewType.includes("word") ||
                            previewType.includes("octet-stream")) && (
                                <a href={previewUrl} download="document" style={{ color: "blue" }}>
                                    Click here to download file
                                </a>
                            )}
                    </>
                )}
            </div>
        </div>
    );
};
export default Document;